const CLASS_ROUTE_FIELDS = Object.freeze([
  { maxLength: 512, param: 'classJoin', storageKey: 'pendingClassJoinToken' },
  { maxLength: 4096, param: 'classCheckIn', storageKey: 'pendingClassCheckInToken' },
  { maxLength: 128, param: 'classSeason', storageKey: 'pendingClassSeasonId' },
]);

export function sanitizeClassRouteValue(value, maxLength) {
  const result = String(value || '')
    .replace(/[^A-Za-z0-9_.-]/g, '')
    .slice(0, maxLength);
  return result || null;
}

export function capturePendingClassRoute({
  hash = '',
  pathname = '/',
  replaceUrl,
  search = '',
  setValue,
} = {}) {
  const params = new URLSearchParams(search);
  const captured = {};
  let containsSensitiveQr = false;

  CLASS_ROUTE_FIELDS.forEach(({ maxLength, param, storageKey }) => {
    const value = sanitizeClassRouteValue(params.get(param), maxLength);
    if (!value) return;
    captured[param] = value;
    setValue?.(storageKey, value);
    if (param === 'classJoin' || param === 'classCheckIn') {
      params.delete(param);
      containsSensitiveQr = true;
    }
  });

  if (containsSensitiveQr && typeof replaceUrl === 'function') {
    const query = params.toString();
    replaceUrl(`${pathname}${query ? `?${query}` : ''}${hash}`);
  }
  return captured;
}
